// lbl.profile
export const profile = {
    firstname: {
        name: 'ชื่อ',
        placeholder: 'ชื่อ',
        required: 'กรุณากรอกชื่อ',
        too_short: '',
        invalid: '',
    },
    lastname: {
        name: 'นามสกุล',
        placeholder: 'นามสกุล',
        required: 'กรุณากรอกนามสกุล',
        too_short: '',
        invalid: '',
    },
    contactNumber: {
        name: 'เบอร์โทรศัพท์',
        placeholder: 'เบอร์โทรศัพท์',
        required: 'กรุณากรอกเบอร์โทรศัพท์',
        too_short: 'เบอร์โทรศัพท์ต้องมี {0} หลัก',
        invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
    },
    email: {
        name: 'อีเมล',
        placeholder: 'อีเมล',
        required: 'กรุณากรอกอีเมล',
        too_short: '',
        invalid: 'อีเมลไม่ถูกต้อง',
    },
    idCard: {
        name: 'เลขบัตประชาชน',
        placeholder: 'เลขบัตประชาชน',
        required: 'กรุณากรอกเลขบัตประชาชน',
        too_short: 'กรุณากรอกเลขบัตประชาชน 13 หลัก',
        invalid: 'เลขบัตรประชาชนไม่ถูกต้อง',
    },
    password: {
        name: 'รหัสผ่าน',
        placeholder: 'รหัสผ่าน',
        required: 'กรุณากรอกรหัสผ่าน',
        too_short: '',
        invalid: '',
    },
    gender: {
        name: 'เพศ',
        placeholder: 'กรุณาเลือก',
        required: 'กรุณาเลือกเพศ',
        too_short: '',
        invalid: '',
    },
    birthdate: {
        name: 'วันเกิด',
        placeholder: '',
        required: 'กรุณาเลือกวันเกิด',
        too_short: '',
        invalid: 'กรุณาเลือกใันที่ให้ถูกต้อง',
        date: {
            name: '',
            defaultText: 'วัน',
            required: ' '
        },
        month: {
            name: '',
            defaultText: 'เดือน',
            required: ' '
        },
        year: {
            name: '',
            defaultText: 'ปี',
            required: ' '
        },
    },
    zipcode: {
        name: 'รหัสไปรษณีย์',
        placeholder: 'รหัสไปรษณีย์',
        required: 'กรุณากรอกรหัสไปรษณีย์',
        too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
        invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
    },
    subdistrict: {
        name: 'แขวง/ตำบล',
        placeholder: 'กรุณาเลือกแขวง/ตำบล',
        required: 'กรุณาเลือกแขวง/ตำบล',
        too_short: '',
        invalid: '',
    },
    district: {
        name: 'เขต/อำเภอ',
        placeholder: 'กรุณาเลือกเขต/อำเภอ',
        required: 'กรุณาเลือกเขต/อำเภอ',
        too_short: '',
        invalid: '',
    },
    province: {
        name: 'จังหวัด',
        placeholder: 'กรุณาเลือกจังหวัด',
        required: 'กรุณาเลือกจังหวัด',
        too_short: '',
        invalid: '',
    },

    male: "ชาย",
    female: "หญิง",
    notspecified: "ไม่ระบุ",

    applyCard: {
        default: 'สมัครบัตร JCB',
        selectBank: 'เลือกธนาคารที่สนใจ'
    },
    addCard: "เพิ่มบัตร",
    quickMenu: {
        history: "ประวัติการแลกรับสิทธิ์",
        applyCard: "สมัครบัตร"
    },
    myCard: "บัตรของฉัน",
    editProfile: "Edit Profile",
    editSuccess: "Edit Profile successfully",
    deleteCardSuccess: "You have successfully <br />Deleted the card",
    confirmDeleteCardTitle: "ยืนยันการลบบัตร ?",
    dateOfBirth: "วันเดือนปีเกิด",
    phoneNumber: {
        default: "เบอร์โทรศัพท์"
    },
    emailLabel: "อีเมล",
    redeemHistory: "ประวัติการแลกรับสิทธิ์",
    popupCampaign: {
        title: "ขอขอบคุณสำหรับการลงทะเบียนกับ JCB Thailand",
        availableQty: "จำนวนสิทธิ์คงเหลือ {0} สิทธิ์"
    },
    // btnCancelMember: "หากต้องการยกเลิกสมาชิก ติดต่อ",
    btnCancelMember: "ยกเลิกสมาชิก",
    popupCancelMember: {
        title: "ยืนยันการขอยกเลิกสมาชิก?",
        msg: "",
        titleSuccess: "ดำเนินการยกเลิกสมาชิกเรียบร้อย"
    },
    privacySetting: 'ตั้งค่าความเป็นส่วนตัว',
    thirdpartySource: {
        title: "REGISTRATION SUCCESSFUL!",
        msg: "TO ENJOY JCB PROMOTIONS, PLEASE ADD A CARD.",
        btnOk: "Add Card",
        btnApply: "Apply Card"
    },
    receivePromotion: {
        title: "YOUR CARD HAS BEEN ADDED",
        msg: "PLEASE WAIT A MOMENT WHILE WE SEND THE PROMOTION VIA LINE MESSAGE",
        btnOk: "OK",
    },
    thirdpartyIsCard: {
        title: "YOUR CARD HAS BEEN ADDED",
        msg: "PLEASE WAIT A MOMENT WHILE WE SEND THE PROMOTION VIA LINE MESSAGE",
        btnOk: "OK",
    },
};
